import { useState, useEffect } from "react";
import { getAdminInfo } from "../api";
import { hasAddonOrOwner, COMPANY_ADDONS } from "../utils/addons";
import { User } from "../types/types";

interface UseReviewsAccessReturn {
    user: User | null;
    hasAccess: boolean;
    loading: boolean;
    error: string | null;
}

/**
 * Access to reviews: Rewind owner (isOwner) or company "reviews" addon.
 */
export const useReviewsAccess = (): UseReviewsAccessReturn => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchUser = async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                setError("No authentication token found");
                setLoading(false);
                return;
            }

            try {
                const response = await getAdminInfo({ token });
                if (!response) {
                    setError("Failed to fetch user information");
                } else {
                    setUser(response);
                }
            } catch (err) {
                console.error("Error fetching user:", err);
                setError("Failed to fetch user information");
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    const hasAccess = hasAddonOrOwner(user, COMPANY_ADDONS.REVIEWS);

    return {
        user,
        hasAccess,
        loading,
        error,
    };
};
